module.exports = __webpack_public_path__ + "img/76.387cd338.png";